import { Pie, PieChart } from "recharts";

const SCALE = 0.85; // Adjust this value to resize the entire chart

const DATA = [{ value: 100 }];
const cx = 80 * SCALE;
const cy = 80 * SCALE;
const iR = 55 * SCALE;
const oR = 80 * SCALE;

interface PieChartProps {
  value: number;
}

export function PieChartWithNeedle({ value }: PieChartProps) {
  return (
    <PieChart width={170 * SCALE} height={90 * SCALE}>
      <defs>
        <linearGradient id="qualityGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#f97316" />
          <stop offset="30%" stopColor="#fbbf24" />
          <stop offset="70%" stopColor="#4ade80" />
          <stop offset="100%" stopColor="#4ade80" />
        </linearGradient>
      </defs>
      <Pie
        isAnimationActive={false}
        dataKey="value"
        startAngle={180}
        endAngle={0}
        data={DATA}
        cx={cx}
        cy={cy}
        innerRadius={iR}
        outerRadius={oR}
        stroke="none"
        fill="url(#qualityGradient)"
      ></Pie>
      {renderNeedle(value, cx, cy, oR)}
    </PieChart>
  );
}

function renderNeedle(value: number, cx: number, cy: number, oR: number) {
  const RADIAN = Math.PI / 180;
  const ang = 180 - (value * 180) / 100;
  const length = oR - 10 * SCALE;
  const sin = Math.sin(-RADIAN * ang);
  const cos = Math.cos(-RADIAN * ang);
  const roundedCx = Math.round(cx);
  const xp = Math.round(roundedCx + length * cos);
  const yp = cy + length * sin;
  const r = 4 * SCALE;
  const xba = Math.round(roundedCx + r * sin);
  const yba = cy - r * cos;
  const xbb = Math.round(roundedCx - r * sin);
  const ybb = cy + r * cos;

  return (
    <g>
      <path d={`M${xba} ${yba} L${xbb} ${ybb} L${xp} ${yp} Z`} fill="#1f2937" />
      <circle cx={roundedCx} cy={cy} r={8 * SCALE} fill="#1f2937" />
    </g>
  );
}

export default function Component() {
  return (
    <div className="flex items-center justify-center p-8">
      <PieChartWithNeedle value={75} />
    </div>
  );
}
